
var strokeImages8lb = {
  "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-1_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-1_PDF.pdf?v=1749578351" },
  "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-2_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-2_PDF.pdf?v=1749578350" },
  "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-3_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-3_PDF.pdf?v=1749578351" },
  "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-4_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-4_PDF.pdf?v=1749578350" },
  "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-5_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-5_PDF.pdf?v=1749578350" },
  "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-6_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-6_PDF.pdf?v=1749578351" },
  "7": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-7_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-7_PDF.pdf?v=1749578350" },
  "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-8_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-8_PDF.pdf?v=1749578350" }
};

var strokeImages16lb = {
  "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-1_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-1_PDF.pdf?v=1749578350" },
  "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-2_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-2_PDF.pdf?v=1749578350" },
  "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-3_PNG.png?v=1749580009", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-3_PDF.pdf?v=1749578350" },
  "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-4_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-4_PDF.pdf?v=1749578351" },
  "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-5_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-5_PDF.pdf?v=1749578350" },
  "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-6_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-6_PDF.pdf?v=1749578351" },
  "7": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-7_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-7_PDF.pdf?v=1749578351" },
  "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-8_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-8_PDF.pdf?v=1749578350" }
};

var strokeImages38lb = {
  "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-1_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-1_PDF.pdf?v=1749578351" },
  "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-2_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-2_PDF.pdf?v=1749578350" },
  "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-3_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-3_PDF.pdf?v=1749578350" },
  "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-4_PNG.png?v=1749580009", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-4_PDF.pdf?v=1749578350" },
  "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-5_PNG.png?v=1749580009", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-5_PDF.pdf?v=1749578350" },
  "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-6_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-6_PDF.pdf?v=1749578351" },
  "7": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-7_PNG.png?v=1749580008", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-7_PDF.pdf?v=1749578350" },
  "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-8_PNG.png?v=1749580009", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-8_PDF.pdf?v=1749578351" }
};

  
  
  jQuery(document).ready(function ($) {
  var strokeSelector = document.getElementById("strokeSelector");
  var forceSelector = document.getElementById("forceSelector");
  var strokeImage = document.getElementById("strokeImage");
  var imageLink = document.getElementById("imageLink");

  
  function updateImage() {
    var stroke = strokeSelector.value;
    var force = forceSelector.value;
    var selectedMap;
    if (force === "8") {
      selectedMap = strokeImages8lb;
    } else if (force === "16") {
      selectedMap = strokeImages16lb;
    } else if (force === "38") {
      selectedMap = strokeImages38lb;
    }

    if (selectedMap[stroke]) {
      strokeImage.src = selectedMap[stroke].img;
      imageLink.href = selectedMap[stroke].link;
    }
  }
  function preloadImages(map) {
    Object.values(map).forEach(entry => {
      const img = new Image();
      img.src = entry.img;
    });
  }
  window.addEventListener('load', () => {
    setTimeout(() => {
      preloadImages(strokeImages8lb);
      preloadImages(strokeImages16lb);
      preloadImages(strokeImages38lb);
    }, 500);
  });
  
  strokeSelector?.addEventListener("change", updateImage);
  forceSelector?.addEventListener("change", updateImage);
  




  function bindDropdownListeners() {
    const dropdownToggles = document.querySelectorAll(".dropdown-trigger");
    dropdownToggles.forEach(trigger => {
      if (!trigger.dataset.listenerAdded) {
        trigger.dataset.listenerAdded = "true";
        trigger.addEventListener("click", () => {
        const detailsSection = trigger.nextElementSibling;
        if (detailsSection) {
          detailsSection.style.transition = "max-height 0.3s ease, padding 0.3s ease";

          if (detailsSection.classList.contains("open")) {
            // Close
            detailsSection.style.maxHeight = "0px";
            detailsSection.classList.remove("open");
          } else {
            // Open
            detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
            detailsSection.classList.add("open");

            // If content includes images, re-measure once they load
            detailsSection.querySelectorAll("img").forEach(img => {
              if (!img.complete) {
                img.addEventListener("load", () => {
                  if (detailsSection.classList.contains("open")) {
                    detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
                  }
                });
              }
            });
          }
        }
      });
      }
    });
  }
  // Product tab toggle
  let lastChecked = document.querySelector("input[type='radio'][name='productTabs']");
  document.querySelectorAll("input[type='radio'][name='productTabs']").forEach(radio => {
    radio.addEventListener("click", function () {
      if (lastChecked === this) {
        this.checked = false;
        lastChecked = null;
      } else {
        lastChecked = this;
      }
    });
  });

    const contentTarget = document.querySelector(".fg-product-additional-content");
    if (contentTarget) {
      const contentObserver = new MutationObserver(() => {
        bindDropdownListeners();
        hideNearestH2Above(".site-wrapper");
        setupYouTubeThumbnails();
      });
      contentObserver.observe(contentTarget, { childList: true, subtree: true });
    }

    // Function to hide nearest <h2> above a target
    function hideNearestH2Above(selector) {
      const element = document.querySelector(selector);
      if (!element) return;

      let h2 = element.previousElementSibling;
      while (h2 && h2.tagName !== "H2") {
        h2 = h2.previousElementSibling;
      }

      if (h2) h2.style.display = "none";
    }

    
    function setupYouTubeThumbnails() {
      var youtube = document.querySelectorAll(".youtubeVideo:not([data-initialized])");
      youtube.forEach(el => {
        el.dataset.initialized = "true";
        el.addEventListener("click", function () {
          var iframe = document.createElement("iframe");
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("allow", "autoplay");
          iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");
          this.innerHTML = "";
          this.appendChild(iframe);
        });
      });
    }

    // Initial bindings
    bindDropdownListeners();
    hideNearestH2Above(".site-wrapper");
    setupYouTubeThumbnails();

  });
